import moment from 'moment';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';
import { Header } from 'datastake-daf/dist/components';
import Program from '../widgets/program';
import AmpsMap from '../widgets/amps-map';
import Overview from '../widgets/overview';
import Style from '../../../../../Analysis/style';
import Loading from '../../../../../../components/Loading';
import AnalysisWidget from '../../../../../Analysis/widget';
import AmpService from '../../../../../../services/AmpService';
import LayoutStyle from '../../../../../Analysis/layouts/style';
import { capitalize } from '../../../../../../helpers/StringHelper';


const renderDate = () => {
  const date = moment();
  const dayString = capitalize(date.format('dddd'));
  const dayNumber = capitalize(date.format('DD'));
  const month = capitalize(date.format('MMMM'));

  return i18next.language === 'en' ? `${dayString}, ${dayNumber} of ${month}`
    : `${dayString} ${dayNumber} ${month}`;
}

export default function TIFDashboard() {
  const { t } = useTranslation();
  const [data, setData] = useState(undefined);
  const { user } = useSelector((state) => state.authentication);

  useEffect(() => {
    const _fetch = async () => {
      try {
        const res = await AmpService.getTifDashboard(user.id);
        setData({
          ...res.data,
          options: res.data.options || { minerals: [], countries: [] },
        });
        return;
      } catch (err) {
        console.log(err);
        setData({ options: { minerals: [], countries: [] } });
      }
    };

    _fetch();
  }, [])

  if (!data) {
    return <Loading />;
  }

  return (
    <Style>
      <Header
        title={`${t('Welcome Back')}, ${user?.firstName}!`}
        supportText={renderDate(t)}
        actionButtons={[
          {
            icon: <DownloadOutlined />,
            onClick: () => { },
            disabled: true,
          }
        ]}
      />

      <div className="content">
        <div className="view-content">
          <LayoutStyle>
            <div className='sections-cont w-pt'>
              <section>
                <Overview options={data?.options} data={data?.overview} />
              </section>

              <section>
                <AmpsMap options={data?.options} data={data?.amps} />
              </section>

              {(data?.programs || []).length ? (
                <AnalysisWidget title={t('Programs')}>
                  {data.programs.map((program) => (
                    <Program
                      id={program.id}
                      key={program.id}
                      name={program.name}
                      clients={program.clients}
                      workers={program.workers}
                      investments={program.investments}
                      logo={(program.logo || [])[0]?.url}
                      picture={(program.picture || [])[0]?.url}
                    />
                  ))}
                </AnalysisWidget>
              ) : null}
            </div>
          </LayoutStyle>
        </div>
      </div>
    </Style>
  )
}
